import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Page from '@zg-rentals/multibrand-ui/lib/Page';
import HeaderNav from '@zg-rentals/multibrand-ui/lib/HeaderNav';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import { PageFooter } from '@zillow/page-frame';

import sharedConfig from '../../../sharedConfig';
import pathsManifest from '../../../pathsManifest';
import queryUtil from '../../../utils/queryUtils';
import { onPageFrameLinkClick } from '@zg-rentals/datagrail';
import { useAuth } from '../../../AuthProvider';

const HELPER_LINK_PARAM = 'ticket_form_id=360000016927';

const propTypes = {
  query: PropTypes.object,
  brand: PropTypes.oneOf(['zillow', 'hotpads', 'trulia']),
  children: PropTypes.node.isRequired,
  isInWebView: PropTypes.bool,
};

function goToSignInPage(brand) {
  if (typeof window !== 'undefined') {
    const { pathname } = window.location;
    window.location = pathsManifest.signInPage[brand](pathname);
  }
}

function goToLogOutPage(brand) {
  window.location = pathsManifest.logOutPage[brand];
}

const PageTemplate = (props) => {
  const { brand, query, isInWebView, children } = props;
  const { user } = useAuth();
  const { email, loggedIn } = user || {};

  const isZillowBrand = brand === 'zillow';
  let hideHeaderAndFooter = false;
  if (query.hostApp) {
    hideHeaderAndFooter = query.hostApp === 'ios' || query.hostApp === 'android';
  }

  return (
    <>
      <Page limitedWidth helpUrlQuery={HELPER_LINK_PARAM} hideFooter>
        {hideHeaderAndFooter || isInWebView ? (
          <div />
        ) : (
          <HeaderNav isFluid={!isZillowBrand}>
            <HeaderNav.RightSection>
              <HeaderNav.Links>
                <Link type="secondary" href="/">
                  {`Go to ${sharedConfig.brandTitles[brand]}`}
                </Link>
                {email && loggedIn ? (
                  <Link type="secondary" onClick={() => goToLogOutPage(brand)}>
                    Sign out
                  </Link>
                ) : (
                  <Link type="secondary" onClick={() => goToSignInPage(brand)}>
                    Sign in
                  </Link>
                )}
              </HeaderNav.Links>
            </HeaderNav.RightSection>
          </HeaderNav>
        )}
        {children}
        {isZillowBrand && !hideHeaderAndFooter && !isInWebView && (
          <div className="full-width">
            <PageFooter onLinkClick={onPageFrameLinkClick} />
          </div>
        )}
      </Page>
    </>
  );
};

PageTemplate.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    brand: state.app.brand,
    router: state.router,
    query: queryUtil.parse(state.router.location.search),
    isInWebView: state.app.isInWebView,
  };
}

export default withRouter(connect(mapStateToProps)(PageTemplate));
